import { Alert, AlertDescription, Icon, useToken } from "@chakra-ui/react";
import {
  IconInfoSquare,
  IconProgressAlert,
  IconRosetteDiscountCheck,
} from "@tabler/icons-react";
import { cssValueToNumber } from "../CreateObject/formFields/ReactSelectField";

type Props = {
  status?: "error" | "info" | "warning" | "success";
  fontSize?: "md" | "medium" | "xs" | "sm" | "xl";
  title?: string;
  description?: string;
  mt?: number;
  ml?: number;
  mr?: number;
  p?: number;
  w?: string;
  alignSelf?: string;
};

const AppAlert = ({
  status,
  mt = 0,
  p = 2,
  ml = 0,
  mr = 0,
  description = "",
  title = "",
  w = "fit-content",
  alignSelf = "flex-start",
}: Props) => {
  const [fontSize] = useToken("fontSizes", ["md"]);
  const fontSizeValue = cssValueToNumber(fontSize) * 1.5;

  let alertIcon = IconRosetteDiscountCheck;
  let borderTopColor = "green.400";

  if (status === "error") {
    alertIcon = IconProgressAlert;
    borderTopColor = "red.400";
  }
  if (status === "info") {
    alertIcon = IconInfoSquare;
    borderTopColor = "blue.400";
  }
  if (status === "warning") {
    borderTopColor = "yellow.500";
    alertIcon = IconProgressAlert;
  }

  return (
    <Alert
      borderTopWidth={3}
      borderTopColor={borderTopColor}
      alignSelf={alignSelf}
      status={status}
      variant={"subtle"}
      p={p}
      mt={mt}
      mr={mr}
      ml={ml}
      w={w}
      position={"unset"}
      gap={2}
    >
      <Icon w={`${fontSizeValue}px`} h={`${fontSizeValue}px`} as={alertIcon} />

      <AlertDescription fontSize={"sm"}>
        {title}
        {description}
      </AlertDescription>
    </Alert>
  );
};

export default AppAlert;
